
import { Component, Prop } from 'vue-property-decorator';
import { filter, find, mapValues } from 'lodash';
import BasePage from '@/components/BasePage';
import { FilesApi } from '@/api/FilesApi';
import { FileInterface } from '@/interfaces/Files';

@Component
export default class ActionActivitiesTabsTabFiles extends BasePage {
   files: FileInterface[] = [];

   @Prop({ type: Number }) o_id!: number;

   @Prop({ type: [String], default: null }) table!: string | null;

   mounted() {
      // Подписка на событие 'paste' при монтировании компонента
      window.addEventListener('paste', this.handlePaste);

      this.$store.commit('showLoading');
      FilesApi.get(this.o_id, this.table)
         .then(({ a_files }) => {
            this.files = a_files;
         })
         .finally(() => {
            this.$store.commit('hideLoading');
         });
   }

   beforeDestroy() {
      // Отписка от события 'paste' при уничтожении компонента
      window.removeEventListener('paste', this.handlePaste);
   }

   handlePaste(event: Event) {
      if (!(event instanceof ClipboardEvent)) return;

      const items = (event?.clipboardData?.items ?? []) as any[];
      const files = filter(
         mapValues(items, item => (item.kind === 'file' ? item.getAsFile() : null)),
         (f: File | null) => f && (f.type.includes('image/') || f.type.includes('/pdf'))
      );

      if (files.length) {
         this.uploadFiles(files);
      }
   }

   file_id(file: any) {
      return file?.file_id ?? file?.of_id;
   }

   filename(file: any) {
      return file?.file_name ?? file?.of_name;
   }

   downloadFile(f: any) {
      const file_id = this.file_id(f);

      this.$store.commit('showLoading');
      FilesApi.download(this.o_id, file_id, this.table).finally(() => {
         this.$store.commit('hideLoading');
      });
   }

   deleteFile(file: any) {
      this.$store.commit('showLoading');
      const file_id = this.file_id(file);
      FilesApi.delete(this.o_id, file_id, this.table)
         .then(() => {
            const item = find(this.files, { file_id });
            const index = this.files.indexOf(item);

            this.files = this.files.filter((f, i) => i !== index);
         })
         .finally(() => {
            this.$store.commit('hideLoading');
         });
   }

   uploadFiles(files: File[]) {
      if (files.length) {
         this.$store.commit('showLoading');
         FilesApi.upload(this.o_id, files, this.table)
            .then((data: FileInterface[]) => {
               this.files.push(...data);
            })
            .finally(() => {
               this.$refs['upload-file']?.reset();
               this.$store.commit('hideLoading');
            });
      }
   }
}
